'use strict';

const cookie = require('./../../../app_storefront_core_ext/cartridge/js/cookie');
const slickSlider = require('./components/common/SlickSlider');

/**
 * Checks if customer is visiting top-level category and sets cookie with this category ID (site-specific)
 * otherwise same value is retrieved from cookie and logo link URL is updated with parameter 'cgid'
 */
function setVisitedCategory() {
    if (pageContext.topLevelCategory) {
        cookie.set(Resources.COOKIE_VISITED_CATEGORY, pageContext.topLevelCategory);
    }
}

/**
 * @description prevent scrolling
 */

function preventScrollingOnSafari() {
    var _overlay = document.getElementsByClassName('js-overlay-nav')[0];
    var _clientY = null;

    function isOverlayTotallyScrolled() {
        return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
    }

    function disableRubberBand(event) {
        var clientY = event.targetTouches[0].clientY - _clientY;

        if (_overlay.scrollTop === 0 && clientY > 0) {
            event.preventDefault();
        }

        if (isOverlayTotallyScrolled() && clientY < 0) {
            event.preventDefault();
        }
    }

    _overlay.addEventListener('touchstart', (event) => {
        if (event.targetTouches.length === 1) {
            _clientY = event.targetTouches[0].clientY;
        }
    }, false);

    _overlay.addEventListener('touchmove', (event) => {
        if (event.targetTouches.length === 1) {
            disableRubberBand(event);
        }
    }, false);
};

/**
 * @function
 * @description init header elements
 */
function init() {
    if (SitePreferences.CATEGORY_REDIRECT_ENABLED) {
        setVisitedCategory();
    }
}

module.exports = {
    init: function(params) {
        init(params);
        slickSlider.slidehomePageTopSectionCarousel($('.js-slick-slider'));

        $('.arrow-show-menu-slot').removeAttr("href");
        $(".js-nav-system-subnav-drop .menu-slots").each(function(){
            if($(this).html().replace(/<\!--.*?-->/g, "").trim() == ""){
                $(this).parent().closest('.js-nav-system-subnav-drop').remove();
            }     
        });

        //Video Lazy Load Script 
        var lazyvideo = document.querySelectorAll('.lazy-video');
        let lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.intersectionRatio > 0) {
                    if (entry.target.querySelector('source').getAttribute('data-src') !== null) {
                    const source = entry.target.querySelector('source').getAttribute('data-src')
                    entry.target.setAttribute('src', source);
                    }
                    observer.unobserve(entry.target);
                } else {
                    console.log('video out of view');
                }
            });
        });

        lazyvideo.forEach(video => {
            lazyVideoObserver.observe(video);
        });

        //Image Lazy Load Script 
        /** First we get all the non-loaded image elements **/
        var lazyImages = [].slice.call(document.querySelectorAll(".lazyloadimg"));
        /** Then we set up a intersection observer watching over those images and whenever any of those becomes visible on the view then replace the placeholder image with actual one, remove the non-loaded class and then unobserve for that element **/
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.classList.remove("lazy");
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        });
        /** Now observe all the non-loaded images using the observer we have setup above **/
        lazyImages.forEach(function(lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });

        /**
     * @function 
     * @description Lazy Load Script for Picture tag add class lazypicture in picture tag
     */         
      

    var lazyPictures =[].slice.call(document.querySelectorAll(".lazypicture > source"));
    if ("IntersectionObserver" in window && 'IntersectionObserverEntry' in window) {
       let lazyPicObserver = 
        new IntersectionObserver(function(entries, observer) {
           entries.forEach(function(entry) {
            if (entry.isIntersecting) {      
               let lazyImage = entry.target;
               lazyImage.srcset = lazyImage.dataset.srcset;
               lazyImage.nextElementSibling.srcset = lazyImage.dataset.srcset;
               lazyImage.nextElementSibling.classList.add('fade-in');
               lazyImage.parentElement.classList.remove("lazypicture");
               lazyPicObserver.unobserve(lazyImage);
             }
          });
         });
  
       lazyPictures.forEach(function(lazyImage) {
        lazyPicObserver.observe(lazyImage);
       });
    } else {
      
      // Not supported, load all images immediately
      let active = false;
   
      const lazyLoad = function() {
        if (active === false) {
          active = true;
          setTimeout(function() {
            lazyImages.forEach(function(lazyImage) {
              if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
                lazyImage.srcset = lazyImage.dataset.srcset;
                lazyImage.nextElementSibling.src = lazyImage.dataset.srcset;
                lazyImage.nextElementSibling.classList.add('fade-in');
                lazyImage.parentElement.classList.remove("lazypicture");
                
                lazyImages = lazyImages.filter(function(image) {
                  return image !== lazyImage;
                });
    
                if (lazyPictures.length === 0) {
                  document.removeEventListener("scroll", lazyLoad);
                  window.removeEventListener("resize", lazyLoad);
                  window.removeEventListener("orientationchange", lazyLoad);
                }
              }
            });
    
            active = false;
          }, 200);
        }
      };
    
      document.addEventListener("scroll", lazyLoad);
      window.addEventListener("resize", lazyLoad);
      window.addEventListener("orientationchange", lazyLoad);
     }       
        
    }
};
